import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import LeftScrollIcon from "../../../Custom-imeges/Workflows-Icons/leftScrollIcon";
import DoneIcon from "@mui/icons-material/Done";
import {
  appsDataTypes,
  OptionBtnIconStyleResponseFinished,
} from "./workflowDetails";
import {
  ImageSuiteApps,
  TextSuiteApps,
  WorkflowAppInputAndOutputTypes,
  WorkflowAppType,
} from "../../../Helper";
import { TranslatorIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/TranslatorIcon";
import { HumanizeIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/HumanizeIcon";
import { SummarizeIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/SummarizeIcon";
import { ParaphraseIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/ParaphraseIcon";
import { PromptEngineerIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/PromptEngineerIcon";
import { GenerateImgIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerateImgIcon";
import { GenerateLogoIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerateLogoIcon";
import { GenerateIconIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerateIconIcon";
import { GenerateIllsturationsIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerateIllsturationsIcon";
import { BgRemoverIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/BgRemoverIcon";
import { ImageRestoreIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/ImageRestoreIcon";
import { ImageTranscaptionIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/ImageTranscaptionIcon";
import GreaterThanIcon from "../../../Custom-imeges/GreaterThanIcon";
import RightScrollIcon from "../../../Custom-imeges/Workflows-Icons/RightScrollIcon";
import ChatResponseFormat from "../../main-page/components/get-conversation/ChatResponseFormat";
import { OutputImage } from "../../ImageSuite/Components/Shared/OutputImage";
import {
  OptionBtnIconStyle,
  tooltipStyles,
} from "../../TextSuite/Components/TextSuitesBody";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { ExpandGeneratedImageModal } from "../../ImageSuite/Components/Shared/ExpandGeneratedImageModal";
import { workflowTypes } from "../../../Types/Workflow-Types";
import DuplicateTemplateModal from "./DuplicateTemplateModal";
import { GenerationIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerationIcon";
import { useCloneWorkflow } from "../../../store/Apis/WorkflowsApi";

interface WorkflowPreviewProps {
  show: boolean;
  handleClose: () => void;
  subTitle:string;
  workflowData: workflowTypes;
}
const WorkflowPreview = ({
  show,
  subTitle,
  handleClose,
  workflowData,
}: WorkflowPreviewProps) => {
  const [expandOutputImage, setExpandOutputImage] = useState(false);
  const [isScrollable, setIsScrollable] = useState(false);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(false);
  const [selectedAppOrder, setSelectedAppOrder] = useState<number>(1);
  const [isOutputCoped, setIsOutputCoped] = useState<boolean>(false);
  const [selectedWorkflowDetails, setSelectedWorkflowDetails] = useState<
    appsDataTypes[]
  >([]);
  const { CloneWorkflow, isSuccess: cloningSucceeded } = useCloneWorkflow();
  const [isUserInteracted, setIsUserInteracted] = useState<boolean>(false);
  const selectedApp = selectedWorkflowDetails.find(
    (app) => app.appOrder === selectedAppOrder
  );
  const [copyTemplate, setCopyTemplate] = useState<boolean>(false);

  useEffect(() => {
    const checkScroll = () => {
      if (containerRef.current) {
        const { scrollWidth, clientWidth, scrollLeft } = containerRef.current;
        setIsScrollable(scrollWidth > clientWidth);
        setAtStart(scrollLeft === 0);
        setAtEnd(scrollLeft + clientWidth >= scrollWidth - 1);
      }
    };

    checkScroll();
    if (containerRef.current) {
      containerRef.current.addEventListener("scroll", checkScroll);
    }

    window.addEventListener("resize", checkScroll);
    return () => {
      window.removeEventListener("resize", checkScroll);
      if (containerRef.current) {
        containerRef.current.removeEventListener("scroll", checkScroll);
      }
    };
  }, [selectedWorkflowDetails]);

  useEffect(() => {
    const combinedData = workflowData?.apps.map((app) => {
      const result = workflowData?.workflowRuns?.[0].workflowAppResults?.find(
        (res) => res.workflowAppId == app.id
      );
      return {
        appId: app.appId,
        appType: app.appType,
        suiteType: app.suiteType,
        inputType: app.inputType,
        outputType: app.outputType,
        appOrder: app.appOrder,
        input: result?.input || "",
        output: result?.output || "",
        isFinished: !!result,
      };
    });

    setSelectedWorkflowDetails(combinedData);
  }, [workflowData]);

  const handleSetActiveApp = (app: number) => {
    setSelectedAppOrder(app);
    setIsUserInteracted(true);
  };
  useEffect(() => {
    setSelectedAppOrder(1);
  }, [workflowData]);

  useEffect(() => {
    if (selectedWorkflowDetails.length > 1 && !isUserInteracted) {
      let currentIndex = 0;
      const interval = setInterval(() => {
        setSelectedAppOrder(selectedWorkflowDetails[currentIndex].appOrder);
        currentIndex = (currentIndex + 1) % selectedWorkflowDetails.length;
      }, 2000);

      return () => clearInterval(interval);
    }
  }, [selectedWorkflowDetails, isUserInteracted]);
  useEffect(() => {
    if (cloningSucceeded) {
      setCopyTemplate(false);
      handleClose();
    }
  }, [cloningSucceeded]);
  const getAppSelected = (title: string, className?: string) => {
    switch (title) {
      case TextSuiteApps.Translator:
        return (
          <TranslatorIcon
            className={`${className ? className : "text-nav-item-icon"}`}
          />
        );
      case TextSuiteApps.Humanizer:
        return (
          <HumanizeIcon
            className={`${className ? className : "text-nav-item-icon-stroke"}`}
          />
        );
      case TextSuiteApps.Summarizer:
        return (
          <SummarizeIcon
            className={`${className ? className : "text-nav-item-icon"}`}
          />
        );
      case TextSuiteApps.Paraphraser:
        return (
          <ParaphraseIcon
            className={`${className ? className : "text-nav-item-icon"}`}
          />
        );
      case TextSuiteApps.PromptGenerator:
        return (
          <PromptEngineerIcon
            className={`${className ? className : "text-nav-item-icon"}`}
          />
        );
      case ImageSuiteApps.TextToImage:
        return (
          <GenerateImgIcon
            className={`${className ? className : "text-nav-item-icon"}`}
          />
        );
      case ImageSuiteApps.LogoGenerator:
        return (
          <GenerateLogoIcon
            className={`${className ? className : "text-nav-item-icon"}`}
          />
        );
      case ImageSuiteApps.IconGenerator:
        return (
          <GenerateIconIcon
            className={`${className ? className : "text-nav-item-icon"}`}
          />
        );
      case ImageSuiteApps.IllustrationGenerator:
        return (
          <GenerateIllsturationsIcon
            className={`${className ? className : "text-nav-item-icon"}`}
          />
        );
      case ImageSuiteApps.BackgroundRemover:
        return (
          <BgRemoverIcon
            className={`${className ? className : "text-nav-item-icon-stroke"}`}
          />
        );
      case ImageSuiteApps.ImageRestore:
        return (
          <ImageRestoreIcon
            className={`${className ? className : "text-nav-item-icon"}`}
          />
        );
      case TextSuiteApps.TextExtraction:
        return (
          <ImageTranscaptionIcon
            className={`${className ? className : "text-nav-item-icon"}`}
          />
        );
      default:
        return null;
    }
  };

  const handleOpenExpandImage = () => {
    setExpandOutputImage(true);
  };
  const handleCloseExpandImage = () => {
    setExpandOutputImage(false);
  };
  const handleCopyOutput = () => {
    if (selectedApp?.output) {
      navigator.clipboard.writeText(selectedApp.output);
      setIsOutputCoped(true);
      setTimeout(() => {
        setIsOutputCoped(false);
      }, 1000);
    }
  };
  const handleDeplicateTemplate = (workflowTemplateName: string) => {
    CloneWorkflow({
      workflowId: workflowData.id,
      workflowName: workflowTemplateName,
    });
  };
  return (
    <>
      <Modal
        className="d-flex workflow-preview workflow-preview-readOnly  DeleteModal"
        show={show}
        centered
        onHide={handleClose}
      >
        <Modal.Header closeButton className="modelSettingsPopupHeader border-0">
          <Modal.Title className="settingPopupHeader">
           {workflowData?.name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          className={`SettingModalBody border-0 px-2 rounded-bottom-4 py-0`}
        >
          <div className="row">
            <div className=" model-data-container ">
              <Box
                className={` parentWorkflowBody`}
                sx={{
                  height: "95%",
                  width: "900px",
                  gap: "21px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Roboto",
                    fontWeight: "400",
                    fontSize: "14px",
                    lineHeight: "25px",
                    letterSpacing: "0.1px",
                    opacity: "0.8",
                    color: "var(--Main_icons_color)",
                    textAlign: "left",
                    width: "100%",
                    marginTop: "21px",
                  }}
                >
                 {subTitle}
                </Typography>
                <Box
                  className="w-100 d-flex"
                  sx={{
                    height: "88%",
                    maxWidth: "1120px",
                    minHeight: "485px",
                  }}
                >
                  <Box sx={{ width: "100%", height: "88%" }}>
                    <Box className="text-suites-navbar justify-content-between position-relative">
                      {isScrollable && !atStart && (
                        <button
                          className="scroll-leftDetails"
                          onClick={() =>
                            containerRef.current?.scrollBy({
                              left: -100,
                              behavior: "smooth",
                            })
                          }
                        >
                          <LeftScrollIcon className="custom-icon" />
                        </button>
                      )}
                      <Box
                        className="workflow-navbar-details"
                        sx={{ overflowX: "auto" }}
                        ref={containerRef}
                      >
                        {selectedWorkflowDetails?.map((app, i) => (
                          <Box
                            key={i}
                            onClick={() => handleSetActiveApp(app.appOrder)}
                            className="workflow-navbar-item"
                          >
                            <Box
                              className={`workflow-app-nav-Item ${
                                selectedAppOrder === app.appOrder && "active"
                              } ${app.appType?.toLowerCase()} `}
                              style={{ textDecoration: "none !important" }}
                            >
                              {selectedAppOrder !== app.appOrder ? (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    borderRadius: "50%",
                                    backgroundColor: "#12b6ea",
                                    padding: "8px",
                                  }}
                                >
                                  <DoneIcon
                                    sx={OptionBtnIconStyleResponseFinished}
                                  />
                                </Box>
                              ) : selectedAppOrder === app.appOrder ? (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    border: "1px solid #12b6ea",
                                    borderRadius: "50%",
                                    padding: "8px",
                                  }}
                                >
                                  {getAppSelected(
                                    app.appType,
                                    "custom-icon-blue"
                                  )}
                                </Box>
                              ) : (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    border: "1px solid",
                                    opacity: "0.5",
                                    borderRadius: "50%",
                                    padding: "8px",
                                  }}
                                >
                                  {getAppSelected(app.appType)}
                                </Box>
                              )}
                              <span
                                className={`text-nav-item-name ${
                                  app.isFinished && "responseFinished"
                                } ${
                                  selectedAppOrder === app.appOrder && "active"
                                }`}
                                style={{
                                  textDecoration: "none !important",
                                  opacity: app.isFinished ? 1 : 0.5,
                                }}
                              >
                                {app.appType}
                              </span>
                            </Box>
                            {i != selectedWorkflowDetails?.length - 1 && (
                              <GreaterThanIcon className="custom-icon-stroke" />
                            )}
                          </Box>
                        ))}
                      </Box>
                      {isScrollable && !atEnd && (
                        <button
                          className="scroll-rightDetails"
                          onClick={() =>
                            containerRef.current?.scrollBy({
                              left: 100,
                              behavior: "smooth",
                            })
                          }
                        >
                          <RightScrollIcon className="custom-icon" />
                        </button>
                      )}
                    </Box>
                    <div className={`workflow-input-output-container h-100`}>
                      <div className="workflow-input-output workflow-input">
                        <Box className="workflow-box-container">
                          <Typography className="container-head-title">
                            Input:
                          </Typography>
                          {selectedApp?.inputType ===
                          WorkflowAppInputAndOutputTypes.Text ? (
                            <textarea
                              placeholder="Type or paste your text here.."
                              className="input-workflow"
                              value={
                                selectedApp?.input ||
                                (selectedAppOrder === 0 &&
                                  selectedWorkflowDetails[0]?.input) ||
                                ""
                              }
                              readOnly={true}
                            ></textarea>
                          ) : selectedApp?.inputType ===
                            WorkflowAppInputAndOutputTypes.Image ? (
                            <>
                              <Box
                                sx={{
                                  width: "100%",
                                  height: "100%",
                                  padding: "16px",
                                }}
                              >
                                {selectedApp.input ? (
                                  <img
                                    className="workflow-input-image"
                                    src={selectedApp.input}
                                    style={{
                                      height: "88%",
                                      minWidth: "280px",
                                    }}
                                  ></img>
                                ) : (
                                  <Box className="generate-loading-container">
                                    <Box className="image-suite-generation-loading">
                                      <Box
                                        sx={{
                                          display: "flex",
                                          flexDirection: "column",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <GenerationIcon />
                                        <Typography className="generation-loading-text">
                                          Generate
                                        </Typography>
                                      </Box>
                                    </Box>
                                  </Box>
                                )}
                              </Box>
                            </>
                          ) : null}
                        </Box>
                      </div>
                      <div className="workflow-input-output workflow-output position-relative">
                        <Box className="workflow-box-container">
                          <Typography className="container-head-title">
                            Output:
                          </Typography>

                          <div className="workflow-output-text">
                            {(selectedApp?.outputType ===
                              WorkflowAppInputAndOutputTypes.Text &&
                              selectedApp?.output) ||
                            (selectedAppOrder === 0 &&
                              selectedWorkflowDetails[0]?.output) ? (
                              <ChatResponseFormat
                                response={
                                  selectedApp?.output ||
                                  (selectedAppOrder === 0 &&
                                    selectedWorkflowDetails[0]?.output) ||
                                  ""
                                }
                              />
                            ) : selectedApp?.outputType ===
                              WorkflowAppInputAndOutputTypes.Image ? (
                              selectedApp?.output ? (
                                <OutputImage
                                  slider={false}
                                  outputImage={true}
                                  imgUrl={selectedApp?.output}
                                  isLoading={false}
                                  handleOpenExpandImage={handleOpenExpandImage}
                                />
                              ) : (
                                <Box className="generate-loading-container">
                                  <Box className="image-suite-generation-loading">
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <GenerationIcon />
                                      <Typography className="generation-loading-text">
                                        Generate
                                      </Typography>
                                    </Box>
                                  </Box>
                                </Box>
                              )
                            ) : null}
                          </div>
                          {selectedApp?.output &&
                          selectedApp.output.length > 0 &&
                          selectedApp.suiteType ===
                            WorkflowAppType.TextSuite ? (
                            <Box
                              className="copy-all-option"
                              onClick={handleCopyOutput}
                              sx={{
                                position: "absolute",
                                bottom: "4%",
                                right: "4%",
                              }}
                            >
                              <IconButton color="inherit" size="small">
                                <Tooltip
                                  title={isOutputCoped ? "Copied" : "Copy all"}
                                  arrow
                                  placement="top"
                                  componentsProps={tooltipStyles}
                                >
                                  {isOutputCoped ? (
                                    <DoneIcon sx={OptionBtnIconStyle} />
                                  ) : (
                                    <ContentCopyIcon sx={OptionBtnIconStyle} />
                                  )}
                                </Tooltip>
                              </IconButton>
                            </Box>
                          ) : null}
                        </Box>
                      </div>
                    </div>
                    {expandOutputImage &&
                    selectedApp?.outputType ===
                      WorkflowAppInputAndOutputTypes.Image ? (
                      <ExpandGeneratedImageModal
                        open={expandOutputImage}
                        imgSrc={selectedApp.output}
                        handleClose={handleCloseExpandImage}
                      />
                    ) : null}
                  </Box>
                </Box>
                <Box
                  className="w-100 d-flex justify-content-end align-items-center"
                  sx={{
                    marginBottom: "21px",
                  }}
                >
                  <button
                    className={`apply-btn not-disable workflow-template-btn w-25`}
                    onClick={() => setCopyTemplate(true)}
                  >
                    Copy
                  </button>
                </Box>
              </Box>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {copyTemplate && (
        <DuplicateTemplateModal
          show={copyTemplate}
          handleClose={() => setCopyTemplate(false)}
          templateName={workflowData?.name || ""}
          method={handleDeplicateTemplate}
        />
      )}
    </>
  );
};

export default WorkflowPreview;
